import React, { useEffect, useState } from 'react';
import './DRMAutoRouter.css';
import { useLocation, useNavigate } from 'react-router-dom';
import pidilite_logo from "../../Assets/Images/pidilite_logo.png";
import CryptoJS from 'crypto-js';
import { getNodeServerUrl } from '../../utils/getNodeUrl';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

function decryptParam(encryptedData, key) {
    try {
        const decoded = decodeURIComponent(encryptedData);
        let bytes = CryptoJS.AES.decrypt(decoded, key);
        let decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return decrypted;
    } catch (error) {
        try {
            let bytes = CryptoJS.AES.decrypt(encryptedData, key);
            let decrypted = bytes.toString(CryptoJS.enc.Utf8);
            return decrypted;
        } catch (retryError) {
            return '';
        }
    }
}

const DRMAutoRouter = () => {
    const [meetingId, setMeetingId] = useState('');
    const [dealerCode, setDealerCode] = useState('');
    const [checkingStatus, setCheckingStatus] = useState(false);
    const [error, setError] = useState('');
    
    const query = useQuery();
    const navigate = useNavigate();
    const secretKey = 'ThisIsASecretKey';
    const nodeBaseUrl = getNodeServerUrl();

    useEffect(() => {
        const encryptedId = query.get('id');
        
        if (encryptedId) {
            setError('');
            try {
                const decryptedId = decryptParam(encryptedId, secretKey);
                
                if (decryptedId && decryptedId.trim()) {
                    setMeetingId(decryptedId);
                } else {
                    setError("Invalid QR code. Failed to decrypt meeting ID. Please scan again.");
                }
            } catch (error) {
                setError("Invalid QR code. Failed to decrypt meeting ID. Please scan again.");
            }
        } else {
            setError("No meeting ID found. Please scan the QR code again.");
        }
    }, [query]);

    const handleDealerCodeSubmit = async (e) => {
        e.preventDefault();
        
        if (!dealerCode.trim()) {
            setError("Please enter your Dealer Code");
            return;
        }

        if (!meetingId) {
            setError("Meeting ID not found. Please scan the QR code again.");
            return;
        }

        setCheckingStatus(true);
        setError('');
        
        try {
            const checkStatusUrl = `${nodeBaseUrl}/DRM_Attendance/checkStatus`;
            
            const response = await fetch(checkStatusUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    meetingId: meetingId, 
                    dealerCode: dealerCode.trim() 
                })
            });

            const data = await response.json();

            if (response.ok && data.success) {
                const reEncryptedId = CryptoJS.AES.encrypt(meetingId, secretKey).toString();
                
                if (data.hasAttendance) {
                    const feedbackUrl = `/DRMFeedbackForm?id=${encodeURIComponent(reEncryptedId)}&dealer=${encodeURIComponent(dealerCode.trim())}`;
                    navigate(feedbackUrl);
                } else {
                    const attendanceUrl = `/DRMAttendanceForm?id=${encodeURIComponent(reEncryptedId)}&dealer=${encodeURIComponent(dealerCode.trim())}`;
                    navigate(attendanceUrl);
                }
            } else {
                setError(data.msg || "Failed to check attendance status. Please try again.");
            }
        } catch (error) {
            setError("Network error. Please check your connection and try again.");
        } finally {
            setCheckingStatus(false);
        }
    };

    return (
        <div className="drm-auto-router-container">
            <div className='drm-auto-router-header'>
                <img src={pidilite_logo} alt="Pidilite Logo" className="drm-auto-router-logo" />
            </div>

            <div className="drm-auto-router-content">
                <h1 className="drm-auto-router-title">Dealer Relationship Meet</h1>
                <p className="drm-auto-router-subtitle">Please enter your Dealer Code to continue</p>

                <form onSubmit={handleDealerCodeSubmit} className="drm-auto-router-form">
                    <div className="form-group">
                        <input 
                            type="text" 
                            value={dealerCode}
                            onChange={(e) => setDealerCode(e.target.value)}
                            placeholder="Enter Dealer Code"
                            className="dealer-code-input"
                            disabled={checkingStatus || !meetingId}
                        />
                    </div>

                    {error && <p className="error-message">{error}</p>}

                    <button 
                        type="submit"
                        className="continue-btn" 
                        disabled={checkingStatus || !dealerCode.trim() || !meetingId}
                    >
                        {checkingStatus ? 'Checking...' : 'Continue'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default DRMAutoRouter;
